import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import ContestPhaseIndicator from "./ContestPhaseIndicator";

export default function ContestList() {
  const [contests, setContests] = useState([]);

  useEffect(() => {
    fetchContests();
  }, []);

  const fetchContests = async () => {
    try {
      const response = await axios.get("/api/contest/get_past_contests.php");
      setContests(response.data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  };

  // Helper function to determine contest phase
  const getContestPhase = (contest) => {
    const now = Date.now() / 1000;
    if (now < contest.start_date) return "Upcoming";
    if (now < contest.submissions_end_date) return "Submissions Open";
    if (now < contest.end_date) return "Voting Open";
    return "Ended";
  };

  const now = Date.now() / 1000;
  const currentContest = contests.find(
    (contest) => contest.start_date <= now && contest.end_date > now
  );
  const pastContests = contests
    .filter((contest) => contest.end_date <= now)
    .sort((a, b) => b.end_date - a.end_date);

  return (
    <Container className="mt-4">
      {currentContest && (
        <Row className="justify-content-center">
                  <h2 className="text-center mb-5">Current Contests</h2>
          <Col lg={10}>
          <Link to={`/contests/${currentContest.id}/`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="row align-items-center mb-4">
              <Col md={3} className="text-center">
                <img
                  src={
                    currentContest.image_url ||
                    `https://www.hearthcards.net/images/contest/sketch/${currentContest.id}.svg`
                  }
                  alt="Contest"
                  className="img-fluid mb-md-0 mb-2 mt-4 mt-md-1"
                  style={{ maxHeight: "100%", padding: "5px" }}
                />
              </Col>
              <Col md={9}>
  <div className="text-center text-md-start mb-1">
    <h2 className="d-inline">{currentContest.title}</h2>
    {currentContest.idea && (
      <small className="text-muted ms-2">
        Idea by{" "}
        <Link
          to={`/user/${currentContest.idea.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {currentContest.idea.username}
        </Link>
      </small>
    )}
  </div>

  <p
    className="lead text-center text-md-start"
    dangerouslySetInnerHTML={{ __html: currentContest.description }}
  ></p>
</Col>

            </div>
            </Link>
            <div className="custom-separator my-5">
              <div className="separator-end"></div>
              <div className="separator-middle"></div>
              <div className="separator-end right"></div>
            </div>
          </Col>
        </Row>
      )}

      <Row className="justify-content-center mb-5">
        <Col lg={10}>
          <h2 className="text-center mb-5">Past Contests</h2>
          <Row>
            {pastContests.length > 0 ? (
              pastContests.map((contest) => (
                <Col key={contest.id} xs={6} md={3} className="mb-4 text-center"> {/* Updated Col here */}
                  <Link to={`/contests/${contest.id}/`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div className="ratio ratio-1x1 mb-2"> {/* Added ratio wrapper for image */}
                      <img
                        src={
                          contest.image_url ||
                          `https://www.hearthcards.net/images/contest/sketch/${contest.id}.svg`
                        }
                        alt={contest.title}
                        className="img-fluid"
                        style={{ objectFit: 'cover' }} // Ensure image covers the area
                      />
                    </div>
                    <div style={{ fontSize: "1rem", wordWrap: 'break-word' }}> {/* Title Style */}
                      {contest.title}
                    </div>
                  </Link>
                </Col>
              ))
            ) : (
              <div className="text-center">No past contests available.</div>
            )}
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
